import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import { useLang } from "@/i18n";

export const Footer = () => {
  const { t } = useLang();
  const contacts = [
    { icon: MessageCircle, label: t.contact.whatsapp, value: "+57 310 684 6758", href: "https://wa.me/573106846758", testid: "contact-whatsapp" },
    { icon: Instagram, label: t.contact.instagram, value: "@pame.3d", href: "https://instagram.com/pame.3d", testid: "contact-instagram" },
    { icon: Mail, label: t.contact.email, value: "pamelamg98@gmail.com", href: "mailto:pamelamg98@gmail.com", testid: "contact-email" },
  ];

  return (
    <footer id="contacto" className="relative bg-[#132A1D] text-[#F7F5F0] grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-20 md:py-32">
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-[#C86A4B] font-bold mb-4">{t.contact.title}</p>
            <h2 className="font-serif-d text-4xl md:text-5xl font-medium leading-tight mb-4">{t.contact.sub}</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {contacts.map((c) => (
              <div key={c.testid} data-testid={c.testid} className="flex items-start gap-3">
                <c.icon size={20} className="text-[#C86A4B] mt-1 shrink-0" />
                <div>
                  <p className="text-xs uppercase tracking-wider text-white/50 mb-1">{c.label}</p>
                  <a href={c.href} target="_blank" rel="noopener noreferrer" className="text-sm md:text-base font-medium hover:text-[#C86A4B] transition-colors duration-200">{c.value}</a>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="border-t border-white/10 pt-10">
          <p className="font-serif-d italic text-2xl md:text-3xl text-white/80 mb-8">{t.footer.tagline}</p>
          <p aria-hidden="true" className="font-serif-d font-semibold text-[13vw] md:text-[9vw] leading-none tracking-tight text-white/10 select-none whitespace-nowrap">
            pame3d
          </p>
          <div className="flex flex-wrap items-center justify-between gap-4 mt-8 text-xs text-white/40">
            <p>© {new Date().getFullYear()} Miss Pam Transforma. {t.footer.rights}</p>
            <div className="flex gap-5">
              <a href="/juegos/" data-testid="footer-juegos-link" className="hover:text-white/70 transition-colors duration-200">{t.nav.juegos}</a>
              <Link to="/galeria" data-testid="footer-galeria-link" className="hover:text-white/70 transition-colors duration-200">{t.nav.galeria}</Link>
              <Link to="/contacto" data-testid="footer-contacto-link" className="hover:text-white/70 transition-colors duration-200">{t.nav.contacto}</Link>
              <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white/70 transition-colors duration-200">Admin</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
